import { LOGGED_OUT_FEATURE_FLAGS, TrafficType, USER_FEATURE_FLAGS } from 'constants/featureFlags';

/**
 * Determine whether or not a provided Split feature flag is valid (matches) with
 * the current global Split client's traffic type.
 *
 * @param {FeatureFlag} featureFlag - The feature flag to check for validity.
 * @returns {boolean} Whether or not the provided feature flag matches the current traffic type.
 */
export const isValidTrafficType = ({ featureFlag }) => {
    const trafficType = localStorage.getItem('customerID') ? TrafficType.USER : TrafficType.LOGGED_OUT;

    const validLoggedOutTraffic =
        trafficType === TrafficType.LOGGED_OUT && LOGGED_OUT_FEATURE_FLAGS.includes(featureFlag);

    const validUserTraffic = trafficType === TrafficType.USER && USER_FEATURE_FLAGS.includes(featureFlag);

    if (validLoggedOutTraffic || validUserTraffic) {
        return true;
    }

    return false;
};
